import { languageDetect } from 'src/paraphraser/handlers/api';
import {
  GUID,
  isElementInViewport,
  getPxFromVh,
  detectAgent,
  insertTextAtCursor,
} from 'core/utils';
import FireStore from '@FireStore';
import { CHAR_LIMITS, IndexedDb, modeSequenceMap } from 'config/constants';
import Track from 'src/paraphraser/handlers/track';
import CoreTrack from 'core/logger/track';
import Logger from 'core/logger/logger';
import Stats from './Stats.js';
import QuillLocalStorage from 'core/utils/localStorageClient';
import CONSTANTS, { QUILL_SETTINGS, SPANISH_SPEAKING_COUNTRIES } from '../constants';
import { openToastr, openSignUpModel } from 'src/_common/handlers/services';
import { openAlertDialog } from '@Common/handlers/services';
// import QuillEventEmitter from 'core/utils/quillEventEmitter';
import Firestore from '@FireStore';
import { APP_SETTINGS } from 'config/constants';
import logger from 'core/logger/logger';
import { chunkSubstr, getTimeDifference, getWordCount } from 'src/_common/handlers/helper';
import cyrilicData from 'public/jsonData/cyrilic_lookup.json';
import axios from 'axios';
import Paraphraser from './paraphraser';
import { sentenceSplitter } from 'src/_common/handlers/api';
import { splitIntoSentences } from 'core/utils/sentenceSplitter';
import { setOutputParaphraserUpdater, setDialogState } from '../actions/paraModelActions';
import { getReduxStore } from 'src/_common/redux/store';
import Bugsnag from 'core/libs/bugsnag';
import IndexDbStoreOld from 'core/utils/indexDb';
import IndexDbStore from 'core/utils/indexedDbClient';
import WaltCache from './walt_cache';
import { longestCommonSubstring } from 'core/utils';
import { findBestMatch } from 'string-similarity';

// import Paraphraser from './paraphraser.js';
// const modeState = () => getReduxStore()?.getState().common?.platform;

var ParaModel = new (function () {
  this.extraText = '';
  this.outputEdited = false;
  this.articleSubmissionTime = null;
  this.inputOnChange = null;
  this.prevState_paraphrasers = [];
  this.textBeforeResetState = '';
  this.prevState_inputSentences = {};
  this.prevState_focusedParaphraser = {};
  this.reportWord = {};
  this.recommendedFreezeWords = [];
  //Language change
  this.promiseResolveWait = undefined;
  this.inputLanguage = 'en';
  this.languageDetectApiCallNumber = 0;
  this.charLimitLanguageCall = 12;
  this.inputBoxLangDetectBanner = false;
  this.outputBoxSpanishLangBanner = false;
  this.spanishLangBanner = false;
  this.spanishLanguageFeedbackGood = false;
  this.spanishLanguageFeedbackBad = false;
  this.languageDetected = undefined;
  this.canMakeDetectCall = true;
  // this.showAcceptTncDialog = false;
  this.isShowLoggedInDialog = () => {};
  this.us2ukData = null;
  this.us2auData = null;
  this.cyrilicCharacter = null;
  // this.inMaintenance = false; // common
  this.moduleContext = ''; // common
  this.language = 'en'; // not needed
  this.isSpamming = false; //leave
  this.dev = false; // leave
  this.paraphrasers = []; // leave
  this.originalParaphrasers = []; //leave
  this.showHelp = {};
  this.prioritize = 'Changes';
  this.focusedParaphraser = null;
  this.originalSubmission = CONSTANTS.DEMO_DEFAULT; // leave
  // this.articleQuilledKey = GUID();
  this.submissionID = GUID();
  // this.inputLength = CONSTANTS.DEMO_DEFAULT.length; //leave
  this.clearFuncs = []; //leave
  this.swapStates = []; //leave
  this.current_char_limit = CHAR_LIMITS.PARAPHRASER_WORD_LIMIT_GUEST;
  this.calcStatsRealTime = false;
  this.toastr = {
    show: false,
    message: '',
    timeout: 0,
    type: '',
    position: { vertical: 'bottom', horizontal: 'left' },
  };
  this.maxCharTrack = true;

  // This variable contains all of the profane terms for which thesaurus will be suppressed.
  this.profaneWords = null;

  this.getNumberOfOccurrences = (string, subString) => {
    let subStringRegExp = new RegExp(`(^| )(${subString})(?=[ ?.,!]|$)`, 'gim');
    return string.match(subStringRegExp)?.length;
  };

  this.stopWords = {};
  if (Object.keys(this.stopWords).length === 0) {
    CONSTANTS.STOP_WORDS.forEach(s => {
      this.stopWords[s] = true;
    });
  }

  this.outputParaphraseArray = () => {
    var arr = [];
    this.paraphrasers.forEach(paraphrase => {
      let output = paraphrase.focusedOutput;
      arr.push(output.getWords());
    });
    return arr;
  };

  this.trackEventForLanguageDetection = (feedBacknature, strength) => {
    let lastSubmission = getReduxStore()?.getState()?.pphr?.lastSubmission;
    Track.spanishlanguageFeedback(
      lastSubmission,
      ParaModel.getModifiedArticle(),
      feedBacknature,
      this.inputLanguage,
      strength
    );
  };

  /**
   *
   * @param {*} dialogName Takes the name of the dialog to check whether to display the dialog for freemium users or not
   * @param {*} dispatch Takes the dispatch to set the state if any dialog is opened or not
   * @returns boolean depicting whether to show dialog or not
   */
  this.isShowLoggedInDialog = (dialogName, dispatch) => {
    // For sync premiumDialog and newModesDialog
    const dialogState = getReduxStore()?.getState()?.pphr?.isDialogOpen;
    const userState = getReduxStore()?.getState()?.user;
    const isNative = getReduxStore()?.getState()?.common.platform?.native;
    let shownLoggedInDialog = false;
    // To show modals only to freemium users.
    if (!dialogName || !userState?.isAuthenticated || userState?.premium || dialogState || isNative)
      return false;
    const dialogKey = 'shown' + dialogName[0].toUpperCase() + dialogName.slice(1);
    const shownModalData = QuillLocalStorage.getInstance().get(dialogKey, '{}');
    let submittedInputCount = userState?.counts?.submittedInputCount || 0;
    // ---> Below code is commented since we don't require it for now, as the modals are called at page load only and we take submittedInputCount from the user
    // const submittedInputCountCookies =
    //   +QuillLocalStorage.getInstance().get('submittedInputCount') || 0;
    // submittedInputCount = Math.max(submittedInputCount, submittedInputCountCookies);
    const modalDisplayed = JSON.parse(shownModalData);
    for (let i = 0; i < CONSTANTS[dialogName].length; i += 1) {
      if (
        !modalDisplayed[CONSTANTS[dialogName][i]] &&
        submittedInputCount >= CONSTANTS[dialogName][i]
      ) {
        modalDisplayed[CONSTANTS[dialogName][i]] = true;
        shownLoggedInDialog = true;
      }
    }
    if (shownLoggedInDialog) {
      CoreTrack.getInstance().shownSection(dialogName);
      QuillLocalStorage.getInstance().set(dialogKey, JSON.stringify(modalDisplayed));
      dispatch(setDialogState(true));
    }
    return shownLoggedInDialog;
  };

  this.showMaintenanceAlert = () => {
    openAlertDialog(
      true,
      'QuillBot Under Maintenance',
      'QuillBot is currently down for maintenance. Check back soon.'
    );
    return;
  };

  this.getDefaultStrength = () => {
    let strength = +QuillLocalStorage.getInstance().get('prioritize', 2);
    if (strength === undefined || !modeSequenceMap.includes(strength)) strength = 2;
    if ([0, 2].indexOf(strength) === -1) {
      if (Firestore.getInstance().authenticated) {
        if (!Firestore.getInstance().isPremiumUser()) {
          if ([1, 3].indexOf(strength) !== -1) strength = 2;
        }
      } else {
        strength = 2;
      }
    }
    // this.strength = strength;
    // dispatch(setStrength(strength));

    // Must not set in Quill Cookies here other wise the last user selected state will be lost
    return strength;
  };

  //Pass the strength and get the default fthresh value
  // this.defaultFthreshStrength = strength => {
  //   if (strength === 2 || strength === 4) return '1';
  //   else return '0';
  // };

  this.getDefaultFthresh = strength => {
    let fthresh = parseInt(
      QuillLocalStorage.getInstance().get(
        'fthresh',
        // this.defaultFthreshStrength(paraModelState()?.strength)
        strength === 2 ? '1' : '0'
      )
    );
    if (QuillLocalStorage.getInstance().get('fthresh', null))
      QUILL_SETTINGS.hasUserInteractedWithWF = true;

    if (fthresh > 3) fthresh = 1;
    if (!Firestore.getInstance().isPremiumUser() && fthresh === 3) {
      if (strength === 0) fthresh = 0;
      else fthresh = 1;
    }

    // QUILL_SETTINGS.fthresh = fthresh;
    // Must not set in Quill Cookies here other wise the last user selected state will be lost
    return fthresh;
  };

  // this.checkPPHRInDefaultState = () => ParaModel.paraphrasers.length === 0;

  // this.registerListeners = () => {
  // QuillEventEmitter.getInstance().setQuillLogout(() => {
  //   QuillEventEmitter.getInstance().on('LOGOUT_SUCCESS_EVENT', () => {
  //     dispatch(
  //       resetStateActionCreator(() => {
  //         if (ParaModel.paraphrasers.length > 0) ParaModel.paraphrasers.length = 0;
  //         dispatch(setStrength(paraModelState()?.strength === 0 ? 0 : 2));
  //         QUILL_SETTINGS.fthresh = paraModelState()?.strength === 0 ? 0 : 1;
  //         QuillLocalStorage.getInstance().set('fthresh', QUILL_SETTINGS.fthresh);
  //         QuillLocalStorage.getInstance().set('prioritize', paraModelState()?.strength);
  //       }, true)
  //     );
  //   });
  // });
  // window.ParaModel = this;
  // QuillEventEmitter.getInstance().setCheckPPHRDefaultState(this.checkPPHRInDefaultState);

  // show spanish language support banner for desktop premium users only 2 times in Spanish countries

  // QuillEventEmitter.getInstance().on('IP_DATA_EVENT', ipData => {
  //   let ipDataCountryCode = '';
  //   if (ipData) {
  //     ipDataCountryCode = ipData?.country_code;
  //     ipDataCountryCode = ipDataCountryCode?.toUpperCase() || '';
  //   }
  //   const spanishBannerShownCount = +QuillLocalStorage.getInstance().get(
  //     'shownSpanishBanner',
  //     '0'
  //   );
  //   if (
  //     getReduxStore()?.getState()?.user?.premium &&
  //     modeState()?.isDesktop &&
  //     spanishBannerShownCount < 2 &&
  //     SPANISH_SPEAKING_COUNTRIES.includes(ipDataCountryCode)
  //   ) {
  //     this.spanishLangBanner = true;
  //     QuillLocalStorage.getInstance().set('shownSpanishBanner', spanishBannerShownCount + 1);
  //   }
  // });
  // };

  //leave
  this.setScrollPosition = modeState => {
    if (!this.focusedParaphraser) return;
    if (modeState?.isMobile) {
      this.prominentContainer = 'output';
    }
    let mainContainer = document.getElementById('inOutContainer');
    const inputBoxElem = document.getElementById('inputText');
    const outputBoxElem = document.getElementById('outputText');
    if (!mainContainer || !inputBoxElem || !outputBoxElem) return;

    const mainContainerRect = mainContainer.getBoundingClientRect();
    const mainContainerHeight = mainContainerRect.height;
    const isBodyScrollNeeded = mainContainerHeight > window.innerHeight; // body scroll will only be applied if main container is bigger than current window height
    const inputBoxDims = inputBoxElem.getBoundingClientRect();
    // keep the focused item within the scollLimit from top and bottom
    let scrollLimit = modeState?.isMobile ? window.innerHeight * 0.3 : window.innerHeight * 0.2;
    const focusedPid = this.focusedParaphraser.pID;
    const focusedInputElem = document.getElementById('inputElements~' + focusedPid);
    const focusedOutputElem = document.getElementById(
      `${CONSTANTS.editableContentIdLabel}~` + this.paraphrasers.indexOf(this.focusedParaphraser)
    );
    if (!focusedInputElem || !focusedOutputElem) return;
    const focusedInputElemRect = focusedInputElem.getBoundingClientRect();
    const focusedOutputElemRect = focusedOutputElem.getBoundingClientRect();

    if (modeState?.isExtension) {
      handleExtensionScroll.call(this, modeState);
    } else if (!isBodyScrollNeeded) {
      handleInternalScroll.call(this, modeState);
    } else {
      switch (this.prominentContainer) {
        case 'input':
          if (!isElementInViewport(focusedInputElem, scrollLimit, scrollLimit)) {
            if (focusedInputElemRect.top < scrollLimit) {
              window.scrollBy({
                top: -(scrollLimit - focusedInputElemRect.top),
                behavior: 'smooth',
              });
            } else {
              scrollLimit = focusedInputElemRect.bottom - (window.innerHeight - scrollLimit);
              if (mainContainerRect.bottom - scrollLimit - 10 < window.innerHeight) {
                scrollLimit = mainContainerRect.bottom - window.innerHeight - 10;
              }
              window.scrollBy({ top: scrollLimit, behavior: 'smooth' });
            }
          }
          handleInternalScroll.call(this, modeState);
          break;
        case 'output':
          if (!isElementInViewport(focusedOutputElem, scrollLimit, scrollLimit)) {
            //when focused element is in top shadow area
            if (focusedOutputElemRect.top < scrollLimit) {
              window.scrollBy({
                top: -(scrollLimit - focusedOutputElemRect.top),
                behavior: 'smooth',
              });
            } else {
              //when focused element in bottom shadow area (scrollLimit)
              scrollLimit = focusedOutputElemRect.bottom - (window.innerHeight - scrollLimit);
              if (mainContainerRect.bottom - scrollLimit - 10 < window.innerHeight) {
                scrollLimit = mainContainerRect.bottom - window.innerHeight - 10;
              }
              window.scrollBy({ top: scrollLimit, behavior: 'smooth' });
            }
          }
          handleInternalScroll.call(this, modeState);
          break;
      }
    }

    function handleInternalScroll(modeState) {
      switch (this.prominentContainer) {
        case 'input': {
          // case no scroll
          const isScrollable = outputBoxElem.scrollHeight > outputBoxElem.clientHeight;
          // case scroll
          if (isScrollable) {
            outputBoxElem.scrollBy({
              top: focusedOutputElemRect.top - focusedInputElemRect.top,
              behavior: 'smooth',
            });
          }
        }
        case 'output': {
          //case no scroll
          const isScrollable = inputBoxElem.scrollHeight > inputBoxElem.clientHeight;

          //case scroll
          if (isScrollable) {
            let scrollByHeight = focusedInputElemRect.top - focusedOutputElemRect.top;
            if (modeState?.isMobile) {
              scrollByHeight = focusedInputElemRect.top - (inputBoxDims.top + 10);
            }
            inputBoxElem.scrollBy({
              top: scrollByHeight,
              behavior: 'smooth',
            });
          }
        }
        default:
      }
    }

    function handleExtensionScroll(modeState) {
      if (modeState?.isExtension) {
        const outputContainer = document.getElementById('articleTextArea');
        const outputContainerDims = outputContainer.getBoundingClientRect();
        // scroll output
        const isScrollableOut = focusedOutputElemRect.bottom > outputContainerDims.bottom;
        const isScrollableOutTop = focusedOutputElemRect.top < outputContainerDims.top;
        // case scroll
        if (isScrollableOut) {
          try {
            outputContainer.scrollBy({
              top: focusedOutputElemRect.bottom - outputContainerDims.bottom + 10,
              behavior: 'smooth',
            });
          } catch (e) {
            console.log('scrollBy not supported');
          }
        } else if (isScrollableOutTop) {
          try {
            outputContainer.scrollBy({
              top: focusedOutputElemRect.top - outputContainerDims.top - 22,
              behavior: 'smooth',
            });
          } catch (e) {
            console.log('scrollTo not supported');
          }
        }
        // scroll input
        const inputContainerElem = document.getElementById('extInputContainer');
        const inputContainerDims = inputContainerElem.getBoundingClientRect();
        const isInputScrollableFromBottom = focusedInputElemRect.bottom > inputContainerDims.bottom;
        const isInputScrollableFromTop = focusedInputElemRect.top < inputContainerDims.top;
        // case scroll
        if (isInputScrollableFromBottom) {
          try {
            inputContainerElem.scrollBy({
              top: focusedInputElemRect.bottom - inputContainerDims.bottom + 22,
              behavior: 'smooth',
            });
          } catch (e) {
            console.log('scrollBy not supported');
          }
        } else if (isInputScrollableFromTop) {
          try {
            inputContainerElem.scrollBy({
              top: focusedInputElemRect.top - inputContainerDims.top - 10,
              behavior: 'smooth',
            });
          } catch (e) {
            console.log('scrollTo not supported');
          }
        }
      }
    }
  };

  //leave
  this.setFocusedInputParaphraser = sentenceList => {
    if (!ParaModel.focusedParaphraser) return;
    let focusedPid = ParaModel.focusedParaphraser.pID;
    let focusedInputParaphraserList = sentenceList.filter(inputParaphrase => {
      if (inputParaphrase.pID === focusedPid) {
        return true;
      } else {
        return false;
      }
    });
    return focusedInputParaphraserList;
  };

  this.callLanguageDetectApi = async inputText => {
    // let inputEl = document.getElementById('inputText');
    // if (!inputEl) return;

    if (inputText.length <= 12) {
      this.defaultStateFordetectCall();
    }

    if (
      inputText.length > this.charLimitLanguageCall &&
      this.languageDetected === undefined &&
      this.charLimitLanguageCall < 52
    ) {
      try {
        let textArray = inputText;

        let threshHold = 0.8;
        if (textArray.length >= 12 && textArray.length < 32) threshHold = 0.92;
        else if (textArray.length >= 32 && textArray.length < 52) threshHold = 0.85;
        else if (textArray.length >= 52) {
          textArray = textArray.substr(0, 52);
          this.charLimitLanguageCall = 52;
          threshHold = 0.8;
        }

        // let textArray = inputEl.innerText.substr(0, this.charLimitLanguageCall);

        if (this.canMakeDetectCall) {
          await this.inputTextLanguageDetect(textArray, threshHold);
          this.canMakeDetectCall = true;
        }
        // this.update('update Called');
        this.charLimitLanguageCall += 20;
        this.languageDetectApiCallNumber += 1;
      } catch (err) {
        console.log(err);
      }
    }
  };

  this.debounce = (func, delay) => {
    let debounceTimer;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(context, args), delay);
    };
  };

  /*This debounce function will be called when user start tying in the input box
     it will assign the prmoise returned from the calllanguageApi to the promise variable  */
  this.callDebounce = inputText => {
    let a = this.debounce(() => {
      this.promiseResolveWait = this.callLanguageDetectApi(inputText);
    }, 300);
    a();
  };

  this.defaultStateFordetectCall = () => {
    this.languageDetectApiCallNumber = 0;
    this.charLimitLanguageCall = 12;
    this.inputLanguage = 'en';
    this.inputBoxLangDetectBanner = false;
    this.outputBoxSpanishLangBanner = false;
    this.spanishLanguageFeedbackGood = false;
    this.spanishLanguageFeedbackBad = false;
    this.languageDetected = undefined;
  };

  this.appicableQuillBoxesHeightInVh = () => {
    return FireStore.getInstance().isPremiumUser()
      ? CONSTANTS.modeContainerHeights.quillBoxesInVhForPremium
      : CONSTANTS.modeContainerHeights.quillBoxesInVh;
  };

  this.getQuillBoxMinHeight = () => {
    let baseMinheight = getPxFromVh(this.appicableQuillBoxesHeightInVh());
    return baseMinheight - CONSTANTS.modeContainerHeights.quillBoxesOffsetInPx;
  };

  this.adjustInputOutputHeights = (modeState, forced) => {
    if (modeState?.isMobile || modeState?.isExtension) return;
    // if (numberOfCompletedParaphrases < this.paraphrasers.length) return;
    if (getReduxStore()?.getState()?.pphr?.startedQuilling) return;
    if (!document.getElementById('inputText')) return;
    if (!document.getElementById('outputText')) return;
    let inputWidth = document.getElementById('inputText').offsetWidth;
    let outputWidth = document.getElementById('outputText').offsetWidth;

    let newProminentContainer = inputWidth > outputWidth ? 'input' : 'output';
    if (this.prominentContainer !== newProminentContainer || forced) {
      this.prominentContainer = newProminentContainer;
      let prominentHeight = 0;
      switch (newProminentContainer) {
        case 'input':
          document.getElementById('inputText').style.maxHeight = 'none';
          prominentHeight = document.getElementById('inputText').offsetHeight;
          if (prominentHeight !== 0 && prominentHeight > this.getQuillBoxMinHeight() + 2)
            document.getElementById('outputText').style.maxHeight = `${prominentHeight}px`;
          break;

        case 'output':
          document.getElementById('outputText').style.maxHeight = 'none';
          prominentHeight = document.getElementById('outputText').offsetHeight;
          if (prominentHeight !== 0 && prominentHeight > this.getQuillBoxMinHeight() + 2)
            document.getElementById('inputText').style.maxHeight = `${prominentHeight}px`;
          break;
      }
    }
    this.setScrollPosition(modeState);
  };

  this.mobileBaseScrollTopPos = 119;

  this.isContenEditableFocusedForMobile = (modeState, isKeyboardOpen, elemName) => {
    if (!modeState?.isMobile) return false;
    const elemMap = {
      input: 'inputText',
      output: CONSTANTS.editableContentIdLabel,
      inputSmzr: 'inputBoxSummarizer',
    };
    if (!isKeyboardOpen && modeState?.isAndroid) return false;
    let activeElem = document.activeElement;
    if (activeElem) {
      if (
        activeElem.id === elemMap.input ||
        activeElem.id === elemMap.output ||
        activeElem.id === elemMap.inputSmzr
      ) {
        if (!elemName) {
          return true;
        }
      }
      return activeElem.id === elemMap[elemName];
    }
    return false;
  };

  this.getLockedParaphrasersLength = () => {
    return ParaModel.paraphrasers.filter(paraObj => paraObj.locked).length;
  };

  this.saveParaphraserData = () => {
    let inputText = getReduxStore()?.getState()?.pphr?.lastSubmission;
    let inputSentences = getReduxStore()?.getState()?.pphr?.inputSentences;
    let isIE = getReduxStore()?.getState()?.common?.platform?.isIE;
    let freezeWords = getReduxStore()?.getState()?.pphr?.freezeWords;

    if (isIE) return;

    if (this.indexedDBSaveDataTimer) clearTimeout(this.indexedDBSaveDataTimer);
    /* Using settimeout because editing output text takes time and 
     we are saving the state after the updation  */

    this.indexedDBSaveDataTimer = setTimeout(() => {
      /* Creating New paraphraser which is a copy of Paaramodel paraphrasers
         But only contains the non cyclic key value pairs excuding functions */

      let historyParaphraser = this.paraphrasers.map(p => {
        var ptemplate = new Paraphraser(null);

        /* The below function will update 
            the new object with the key value pairs without circular dependency */
        ptemplate.saveHistoryData(p);
        return ptemplate;
      });

      // Storing data in the IndexedDb storage
      IndexDbStore.getInstance().setToIndexedDB(
        'historyParaphraser',
        JSON.stringify(historyParaphraser),
        IndexedDb.collections.paraphraseHistory
      );
      if (inputText) {
        IndexDbStore.getInstance().setToIndexedDB(
          'historyInputText',
          JSON.stringify({
            inputText,
            timeSpentOnArticle: getTimeDifference(this.articleSubmissionTime),
          }),
          IndexedDb.collections.paraphraseHistory
        );
      }

      if (this.paraphrasers.length !== 0) {
        IndexDbStore.getInstance().setToIndexedDB(
          'historyInputSentences',
          JSON.stringify(inputSentences),
          IndexedDb.collections.paraphraseHistory
        );
      }

      IndexDbStore.getInstance().setToIndexedDB(
        'historyFreezeWords',
        JSON.stringify(freezeWords),
        IndexedDb.collections.paraphraseHistory
      );
    }, 100);
  };

  this.getIndexedDbData = () => {
    /* 
      Check if the old db store are available then just get all the key value 
      pairs using the oldDB connection then just storing that data into
      the new db i.e qb-store 
      also changing the collections name and deleting the old datastores and collections
    */

    // window?.indexedDB?.databases().then(dbName => {
    // let requiredDb = dbName.filter(eachDb => {
    //   if (['report-store', 'defination-store'].includes(eachDb.name)) return true;
    // });
    // if (requiredDb.length)
    Promise.all([
      IndexDbStoreOld.getInstance().getAllDefinations('definations'),
      IndexDbStoreOld.getInstance().getAllReport('reportedWords'),
      IndexDbStoreOld.getInstance().getAllReport('sentenceReported'),
    ])
      .then(storedData => {
        storedData?.forEach(eachStoreData => {
          if (eachStoreData?.data?.length)
            eachStoreData?.data?.forEach(eachKeyValue => {
              if (eachStoreData.dataStoreName === 'definations')
                eachStoreData.dataStoreName = 'definitions';

              if (eachStoreData.dataStoreName === 'sentenceReported')
                eachStoreData.dataStoreName = 'reportedSentences';
              IndexDbStore.getInstance().setToIndexedDB(
                eachKeyValue.key,
                eachKeyValue.value,
                eachStoreData.dataStoreName
              );
            });
        });
        setTimeout(() => {
          IndexDbStoreOld.getInstance().deleteDatabse();
        });
      })
      .catch(() => {
        Logger('Failed to fetch old data from old indexeddb store', '');
      });
    // });
  };

  // this.loadArticle = article => {
  //   this.paraphrasers = article.paraphrasers.map(p => {
  //     var ptemplate = new Paraphraser(null);
  //     ptemplate.loadExport(p);
  //     return ptemplate;
  //   });
  //   this.makeInputSentences();

  //   if (this.paraphrasers.length > 0) {
  //     dispatch(setFocusedParaphraser(this.paraphrasers[0]));
  //   }
  //   setTimeout(() => {
  //     Stats.updateStats();
  //   }, 200);
  // };

  // if article is passed this will inserttext into input box and quill the article automatically
  // this.autoQuillArticle = (modeState, text) => {
  //   const inputBoxElem = document.getElementById('inputText');
  //   if (!inputBoxElem) {
  //     return;
  //   }
  //   inputBoxElem.focus();
  //   dispatch(setPersistentInputText(''));
  //   inputBoxElem.innerText = '';
  //   if (modeState?.isIE) {
  //     insertTextAtCursor(text);
  //   } else {
  //     document.execCommand('insertText', false, text);
  //   }
  //   // this.reQuillArticle();
  //   dispatch(paraphraseArticle());
  // };

  // this.getMaintenanceState = () => getReduxStore()?.getState().common.maintenance.isMaintenance;

  this.inputTextLanguageDetect = async (text, thresHold = 0.8) => {
    this.canMakeDetectCall = false;

    this.languageDetected = 'en';
    this.inputLanguage = 'en';
    return;

    const languageDetectionResponse = await languageDetect({ text });

    if (languageDetectionResponse.score > thresHold) {
      this.languageDetected = languageDetectionResponse.language;
      this.inputLanguage = languageDetectionResponse.language;
    }
    if (this.inputLanguage === 'es') {
      this.inputBoxLangDetectBanner = true;
    }
  };

  this.freezeWords = (deletedFrozenWordArr, freezeWords) => {
    let inputEl = document.getElementById('inputText');
    if (!inputEl) return;
    if (!inputEl.innerText.trim()) return;
    // const freezeWords = getReduxStore()?.getState()?.common?.freezeWords;
    // In the case of individual delete and clear all cases
    if (deletedFrozenWordArr) {
      // clear all case
      if (deletedFrozenWordArr.length === 0) {
        // call paraphraser's which had freezeWords.
        ParaModel.paraphrasers
          .filter(paraphraser => {
            return paraphraser.frozenWords.length > 0;
          })
          .forEach(p => {
            p.clearBeams();
            p.paraphrase(
              {
                finished: () => {
                  p.edited();
                },
              },
              p.strength
            );
          });
      } else {
        // individual freeze word delete case
        // call paraphrase on only those paraphraser which had the deleted frozen word.
        ParaModel.paraphrasers
          .filter(paraphraser => {
            return paraphraser.frozenWords.includes(deletedFrozenWordArr[0]);
          })
          .forEach(p => {
            p.clearBeams();
            p.paraphrase(
              {
                finished: () => {
                  p.edited();
                },
              },
              p.strength
            );
          });
      }
    }
    // In case of when a new freeze word is added
    else {
      ParaModel.paraphrasers.forEach(paraphraser => {
        for (let frozenWord of freezeWords) {
          if (
            paraphraser.origText.match(
              new RegExp(`(^| )${frozenWord}($|[,?!. ]*[ ]+|[,?!.]$)`, 'i')
            )
          ) {
            paraphraser.clearBeams();
            paraphraser.paraphrase(
              {
                finished: () => {
                  paraphraser.edited();
                },
              },
              paraphraser.strength
            );
            break;
          }
        }
      });
    }
  };

  this.makeWords = final => {
    if (final) {
    }
    // Stats.updateStats();
  };

  // leave
  this.completedParaphrase = () => {
    Logger('Quill Finished', 'finished');
    var paraphraseBtn = document.getElementById('paraphraseBtn');
    if (paraphraseBtn) {
      paraphraseBtn.style.opacity = 1;
      this.isSpamming = false;
    }
    // show signup modal when user has quilled 5, 25 50 times; same array is being used in signupDialog component
    const quillsForModal = [5, 50, 100];
    if (FireStore.getInstance() && !FireStore.getInstance().authenticated) {
      const submittedInputCount = +QuillLocalStorage.getInstance().get('submittedInputCount');
      const signupModalShown = +QuillLocalStorage.getInstance().get('signupModalShownCount');
      for (let i = 0; i < quillsForModal.length; i += 1) {
        // handle showing modal based on how many times it is already shown
        if (submittedInputCount >= quillsForModal[i] && signupModalShown <= i) {
          setTimeout(() => {
            openSignUpModel(true);
          }, 5000);
          break;
        }
      }
    }
    // Stats.updateStats();
    // setTimeout(() => {
    //   Stats.updateStats();
    // }, 4000);
  };

  // this.paraphrase = t => {
  //   if (!this.us2ukData)
  //     axios.get('/jsonData/us2uk_updated.json').then(res => {
  //       this.us2ukData = res.data;
  //     });

  //   //Assuming this request will resolve before single para call.
  //   if (!this.us2auData)
  //     axios.get('/jsonData/us2au_updated2.json').then(res => {
  //       this.us2auData = res.data;
  //     });

  //   if (!this.cyrilicCharacter) this.cyrilicCharacter = cyrilicData;

  //   const isRecaptchaShown = getReduxStore()?.getState().common?.recaptcha?.isShown;
  //   if (isRecaptchaShown) {
  //     dispatch(setStartedQuilling(false));
  //     return;
  //   }
  //   let inputEl = document.getElementById('inputText');
  //   if (!inputEl) {
  //     dispatch(setStartedQuilling(false));
  //     return;
  //   }

  //   dispatch(setStartedQuilling(true));
  //   if (typeof t !== 'string') {
  //     t = null;
  //   }
  //   var text = t ? t : inputEl.innerText;

  //   text = text.trim();
  //   if (text.length === 0) {
  //     text = CONSTANTS.DEMO_DEFAULT;
  //   }

  //   if (text.length > this.current_char_limit) {
  //     console.log('trimming');
  //     text = text.substr(0, this.current_char_limit);
  //     dispatch(setShowCharLimitMessage(false));
  //   }

  //   for (let i = 0; i < text.length; i++) {
  //     if (this.cyrilicCharacter)
  //       if (this.cyrilicCharacter[text[i]]) {
  //         text = text.replace(text[i], this.cyrilicCharacter[text[i]]);
  //       }
  //   }

  //   dispatch(changeNumberOfCharacter(text.length));
  //   if (this.focusedParaphraser) this.focusedParaphraser.outputs = [];

  //   if (paraModelState().firstParaphrase) {
  //     dispatch(setFirstParaphrase(false));
  //   } else {
  //     dispatch(setShowRequillLabel(true));
  //   }

  //   let sentences = splitIntoSentences(text)
  //     .filter(s => s.type === 'Sentence')
  //     .map(s => s.raw);
  //   dispatch(setNumberOfSentencesInArticle(sentences.length));
  //   sentences.length > 1 ? dispatch(setArticleControls(true)) : dispatch(setArticleControls(false));

  //   dispatch(changeLastSubmission(text));
  //   this.originalSubmission = text;
  //   Stats.clearStats();
  //   setTimeout(() => {
  //     var inputText = document.getElementById('inputText');
  //     this.parseArticleSynchronously(text, () => {
  //       this.paraphrasers.forEach(p => {
  //         p.completed = true;
  //         dispatch(
  //           setOutputParaphraserUpdater({
  //             pID: p.pID,
  //           })
  //         );
  //       });

  //       //Call the compare Mode function if user Paraphrase and rephrase the sentence
  //       if (
  //         getReduxStore()?.getState()?.common?.isOpencompareModeDrawer &&
  //         this.focusedParaphraser &&
  //         FireStore.getInstance().isPremiumUser()
  //       )
  //         this.focusedParaphraser.compareModeOn();
  //       if (
  //         getReduxStore()?.getState()?.common?.isOpencompareModeDrawer &&
  //         this.focusedParaphraser &&
  //         !FireStore.getInstance().isPremiumUser()
  //       )
  //         this.focusedParaphraser.compareModeOnNonPremium();
  //       this.makeWords(true);
  //       this.completedParaphrase();
  //       dispatch(setShowRephrase(true));
  //       if (this.updateCharactersInfo) this.updateCharactersInfo();

  //       dispatch(setStartedQuilling(false));
  //       Logger('Quill Finished', 'all is done');
  //     });
  //   }, 200);
  // };

  this.redo = (strength, isMaintenance = false) => {
    if (isMaintenance) {
      this.showMaintenanceAlert();
      return;
    }
    var fp = this.focusedParaphraser;
    // this.articleQuilledKey = GUID();
    fp.redo(
      {
        finished: () => {
          this.completedParaphrase();

          fp.edited(); // = true;
        },
      },
      strength
    );
  };

  // this.panic = (reason, ignoreTrack) => {
  //   if (!ignoreTrack) {
  //     Track.panic(modeState(), reason);
  //     if (this.bugsnagClient) {
  //       this.bugsnagClient.notify(
  //         new Error('Panic Triggered [' + reason.reason + ']: "' + reason.text + '"')
  //       );
  //     }
  //   }
  //   // commenting the panic unpanic flow shown in the feedback section.
  //   return;
  // };

  // this.unpanic = () => {
  //   // commenting the whole panic unpanic flow shown in the feedback section
  //   return;
  // };

  this.changePriority = newP => {
    if (newP !== this.prioritize) {
      if (this.focusedParaphraser !== null) {
        this.focusedParaphraser.pathI = 0;
      }
    }
    this.prioritize = newP;
  };

  this.clearSegPrompts = () => {
    this.paraphrasers.forEach(p => {
      p.clearSegPrompts();
    });
    this.clearFuncs.forEach(c => c());
  };

  this.addClearFunc = f => {
    this.clearFuncs.push(f);
  };

  this.removeClearFunc = f => {
    var i = this.clearFuncs.indexOf(f);
    if (i > 0) {
      this.clearFuncs.splice(i, 1);
    }
  };

  // this.makeInputSentences = () => {
  //   dispatch(setPersistentInputText(''));
  //   dispatch(
  //     setInputSentences({
  //       inputId: GUID(),
  //       sentenceList: this.paraphrasers.map(({ pID, text, indent }) => ({
  //         pID,
  //         text,
  //         indent,
  //       })),
  //     })
  //   );
  // };

  // this.makeParaphrases = input => {
  //   this.submissionID = GUID();
  //   this.inputLength = input.length;

  //   this.paraphrasers = [];
  //   dispatch(setOutputParaphraserUpdater({}));
  //   input = ' ' + input + ' ';
  //   dispatch(setNumberOfCompletedParaphrases(0));
  //   var numP = 0;

  //   let sentences = splitIntoSentences(input);
  //   var numSents = 0;
  //   sentences.forEach(s => {
  //     if (s.type === 'Sentence' && s.raw.length > 2) {
  //       numSents += 1;
  //     }
  //   });
  //   Track.submittedInput(
  //     input,
  //     this.submissionID,
  //     QUILL_SETTINGS.fthresh,
  //     paraModelState()?.strength,
  //     numSents,
  //     ParaModel.inputLanguage
  //   );

  //   var isMulti = numSents > 1;

  //   var makePara = (text, indent) => {
  //     if (text !== null && text !== undefined && typeof text === 'string' && text.length > 0) {
  //       var p = new Paraphraser(
  //         text,
  //         0,
  //         indent,
  //         this.submissionID,
  //         !modeState()?.isDesktop && isMulti
  //       );
  //       p.index = numP;
  //       this.paraphrasers.push(p);
  //       dispatch(
  //         setOutputParaphraserUpdater({
  //           pID: p.pID,
  //           key: 0,
  //         })
  //       );
  //       numP += 1;
  //     }
  //   };

  //   var begun = false;
  //   var linespace = '';
  //   var numberOfLineSpace = 0;
  //   sentences.forEach(s => {
  //     if (s.type === 'Sentence') {
  //       begun = true;
  //       if (modeState()?.isIE) {
  //         let offsetForLines = Math.round(linespace.length / 3) + 1;
  //         linespace = linespace.substring(0, offsetForLines);
  //       }
  //       makePara(s.raw, linespace);
  //       linespace = '';
  //       numberOfLineSpace = 0;
  //     } else if (s.type === 'WhiteSpace') {
  //       if (begun) {
  //         linespace += s.raw;
  //         numberOfLineSpace += 1;
  //       }
  //     }
  //   });
  //   this.makeInputSentences();

  //   if (this.paraphrasers.length === 0) return false;
  //   dispatch(setFocusedParaphraser(this.paraphrasers[0]));
  //   dispatch(
  //     setOutputParaphraserUpdater({
  //       pID: this.paraphrasers[0].pID,
  //     })
  //   );
  //   return true;
  // };

  // this.parseArticleSynchronously = (input, cb) => {
  //   if (!this.makeParaphrases(input)) return;
  //   var paraphrasers = this.paraphrasers;
  //   Stats.updateStats();
  //   var curP = 0;
  //   var finished = 0;
  //   var conti = () => {
  //     if (finished >= paraphrasers.length) {
  //       cb();
  //       return;
  //     }
  //     var p = paraphrasers[curP];

  //     if (p) {
  //       curP += 1;
  //       if (p.locked) {
  //         finished += 1;
  //         dispatch(
  //           setNumberOfCompletedParaphrases(paraModelState()?.numberOfCompletedParaphrases + 1)
  //         );
  //         this.makeWords(false);
  //         conti();
  //       } else {
  //         p.paraphrase(
  //           {
  //             finished: () => {
  //               finished += 1;
  //               dispatch(
  //                 setNumberOfCompletedParaphrases(
  //                   paraModelState()?.numberOfCompletedParaphrases + 1
  //                 )
  //               );
  //               this.makeWords(false);
  //               conti();
  //             },
  //           },
  //           paraModelState()?.strength
  //         );
  //       }
  //     }
  //   };

  //   var premium = FireStore.getInstance() && FireStore.getInstance().isPremiumUser();
  //   var amnt = premium ? 15 : 2;
  //   for (var i = 0; i < amnt; i++) {
  //     conti();
  //   }
  // };

  this.getOriginalArticle = () => {
    // let out = '';
    // this.paraphrasers.forEach(p => {
    //   out += p.origText + ' ';
    // });
    // return out;
    return getReduxStore()?.getState()?.pphr?.lastSubmission?.trim() || '';
  };

  this.getModifiedArticleOnParaphrasers = () => {
    let out = '';
    this.paraphrasers.forEach(p => {
      let output = p.focusedOutput;
      if (output) out += p.indent + output.getOutputString();
    });
    return out;
  };

  this.getModifiedArticle = () => {
    let out = '';
    const outputBox = document.getElementById(CONSTANTS.editableContentIdLabel);
    if (outputBox) {
      out = outputBox.innerText;
    }
    return out;
  };

  this.clearBeams = reason => {
    if (this.paraphrasers && this.paraphrasers.length > 0) {
      this.paraphrasers.forEach(p => {
        p.clearBeams(reason);
      });
    }
  };

  // common,. move to toastr
  this.showToastr = (
    type,
    message,
    timeout = 3000,
    action = undefined,
    undoLabel = '',
    toastrPosition = {
      vertical: 'bottom',
      horizontal: 'left',
    }
  ) => {
    openToastr(message, timeout, action, undoLabel, toastrPosition);
  };

  // this function is being called when copy all btn is clicked;
  // if insert into doc btn is clicked then isInsrted= true
  this.copyAll = (triggeredBy = 'copyAll', selectedText = '') => {
    let lastSubmission = getReduxStore()?.getState()?.pphr?.lastSubmission;
    let freezeWords = getReduxStore()?.getState()?.pphr?.freezeWords;
    var editLog = null;
    var finText = '';

    finText = ParaModel.getModifiedArticle();
    let selectedSentencesArray = [];
    if (
      triggeredBy === 'hotkeyAfterPartialSelection' ||
      triggeredBy === 'rightClickAfterPartialSelection'
    ) {
      const selectedSentences = splitIntoSentences(selectedText);
      selectedSentences.forEach(s => {
        if (s.type === 'Sentence') {
          selectedSentencesArray.push(s.raw);
        }
      });
    }

    var logs = this.getEditLogsOfAllParaphraser();

    var swaps = ParaModel.paraphrasers.map(p => [p.index, p.pID]);
    editLog = {
      logs: logs,
      swaps: swaps,
    };

    ParaModel.paraphrasers.forEach(p => {
      var orig = p.origText;
      var beamOutput = !p.singleParaCallStatus ? '' : p.focusedOutput.beamOutput;
      var flippedOutput = !p.singleFlipCallStatus ? '' : p.lastParaphrase;
      var fin = p.focusedOutput.getOutputString();
      var edits = p.focusedOutput.editLog;
      var strength = p.focusedOutput.strength;
      var modelId = p.singleParaphraseModelData
        ? p.singleParaphraseModelData[strength]?.modelId
        : undefined;
      var ptime = p.focusTime + getTimeDifference(p.focusTimeStart);
      var outTimes = p.outputs.map(o => [
        o.outID,
        o.focusTime + getTimeDifference(o.focusTimeStart),
        o.strength,
      ]);
      var times = { paraTime: ptime, outTimes: outTimes };
      var fthresh = p.focusedOutput.fthresh;
      const frozenWords = p.frozenWords;
      const changedWords = p.focusedOutput?.flips?.length || 0;
      let similarity = true;
      if (
        triggeredBy === 'hotkeyAfterPartialSelection' ||
        triggeredBy === 'rightClickAfterPartialSelection'
      ) {
        const similarityScore = findBestMatch(fin, selectedSentencesArray);
        similarity = similarityScore.bestMatch.rating > 0.9 ? true : false;
      }
      if (similarity) {
        Track.copiedText(
          this.submissionID,
          this.inputLanguage,
          orig,
          beamOutput,
          flippedOutput,
          fin,
          strength,
          edits,
          times,
          fthresh,
          frozenWords,
          changedWords,
          p.focusedOutput?.waltedCount,
          p.focusedOutput?.thesaurusedCount,
          p.focusedOutput?.flipperModelId,
          modelId,
          triggeredBy,
          true,
          p.focusedOutput?.segmentorModeID,
          p.focusedOutput?.totalSegmentsCount,
          p.focusedOutput?.breakSegmentsCount,
          p.outputs?.length
        );
      }
    });

    const usedModelIds = ParaModel.paraphrasers
      .map(paraphrase =>
        paraphrase.singleParaphraseModelData
          ? paraphrase.singleParaphraseModelData[paraphrase.focusedOutput.strength]?.modelId
          : undefined
      )
      .filter(modelId => modelId);
    const articleFrozenWords = [];

    Track.copiedArticle(
      this.submissionID,
      this.inputLanguage,
      lastSubmission,
      finText,
      editLog,
      Array.from(new Set(usedModelIds)),
      Array.from(new Set(freezeWords)),
      triggeredBy,
      selectedText,
      this.outputEdited
    );

    let totalDeletedSentences = 0;
    ParaModel.paraphrasers?.forEach((p, index) => {
      if (!document.getElementById(`${CONSTANTS.editableContentIdLabel}~` + index)) {
        totalDeletedSentences += 1;
      }
    });
    if (totalDeletedSentences)
      Track.sentenceDeletedCount(totalDeletedSentences, ParaModel.paraphrasers?.length);
  };

  this.trackCopySentence = (
    triggeredBy,
    currentOutput,
    compareModeSelected,
    copiedOriginal = false
  ) => {
    if (!this.focusedParaphraser) return;
    currentOutput = currentOutput ? currentOutput : this.focusedParaphraser.focusedOutput;
    var origText = this.focusedParaphraser.origText;
    var beamOutput = !this.focusedParaphraser?.singleParaCallStatus ? '' : currentOutput.beamOutput;
    var flippedOutput = !this.focusedParaphraser?.singleFlipCallStatus
      ? ''
      : currentOutput.paraphraser.lastParaphrase;
    var finText = copiedOriginal ? origText : currentOutput.getOutputString();
    var editLog = currentOutput.editLog;
    var strength = currentOutput.strength;
    var fthresh = currentOutput.fthresh;

    var ptime =
      this.focusedParaphraser?.focusTime +
      getTimeDifference(this.focusedParaphraser?.focusTimeStart);
    var outTimes = this.focusedParaphraser.outputs.map(o => [
      o.outID,
      o.focusTime + getTimeDifference(o.focusTimeStart),
      ,
      o.strength,
    ]);
    var times = { paraTime: ptime, outTimes: outTimes };
    const frozenWords = this.focusedParaphraser.frozenWords;
    const changedWords = currentOutput?.flips?.length || 0;
    Track.copiedText(
      this.submissionID,
      this.inputLanguage,
      origText,
      beamOutput,
      flippedOutput,
      finText,
      strength,
      editLog,
      times,
      fthresh,
      frozenWords,
      changedWords,
      currentOutput.waltedCount,
      currentOutput.thesaurusedCount,
      currentOutput.flipperModelId,
      this.focusedParaphraser.singleParaphraseModelData
        ? this.focusedParaphraser.singleParaphraseModelData[strength]?.modelId
        : undefined,
      triggeredBy,
      compareModeSelected,
      currentOutput?.segmentorModeID,
      currentOutput?.totalSegmentsCount,
      currentOutput?.breakSegmentsCount,
      triggeredBy === 'sentenceControls' ? this.focusedParaphraser?.outputs?.length : undefined
    );
  };

  // leave
  this.lockSentence = (paraphraserObj, cb) => {
    paraphraserObj.locked = true;

    openToastr('Sentence Locked', 3000, this.unlockSentence.bind(this, paraphraserObj, cb), 'Undo');
    Track.sentenceLocked(paraphraserObj);
  };

  this.unlockSentence = (paraphraserObj, cb) => {
    paraphraserObj.locked = false;
    if (cb) cb();
    Track.sentenceUnlocked(paraphraserObj);
  };

  this.unlockAllSentences = cb => {
    ParaModel.paraphrasers.forEach(paraphraseObj => {
      if (paraphraseObj.locked) {
        this.unlockSentence(paraphraseObj);
      }
    });
    if (cb) cb();
  };

  this.setFocusOnMobileOutputBox = (isOutputBoxEditableForMobile, modeState) => {
    if (!modeState?.isMobile) return;
    let editableBox = document.getElementById(CONSTANTS.editableContentIdLabel);
    if (!editableBox) return;
    if (isOutputBoxEditableForMobile) {
      editableBox.focus();
      // alert("Focusing");
      setTimeout(() => {
        editableBox.focus();
      }, 0);
    }
  };
  //New Mobile changes

  this.setVerticalScrollDirection = () => {
    let newBodyScrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    let direction = 'unknown';
    if (!this.previousBodyScrollTop) {
      this.previousBodyScrollTop = 0;
    }
    if (newBodyScrollTop > this.previousBodyScrollTop) {
      direction = 'up';
    } else {
      direction = 'down';
    }
    this.previousBodyScrollTop = newBodyScrollTop;
    this.verticalScrollDirection = direction;
  };

  this.adjustMobileContainerheight = (modeState, isKeyboardOpen) => {
    if (!modeState?.isMobile) return;
    if (ParaModel.isContenEditableFocusedForMobile(modeState, isKeyboardOpen, 'input')) {
      this.moveToBreakPoint(modeState, 2);
      return;
    }
    if (ParaModel.focusedParaphraser && ParaModel.paraphrasers.length > 0) {
      let inputBox = document.getElementById('inputText');
      let outputBox = document.getElementById('outputText');
      let quillBox = document.getElementById('inOutContainer');
      let cicBox = document.getElementById('controlledInputBoxContainer');
      if (!inputBox) return;
      if (!outputBox) return;
      if (!quillBox) return;
      if (!cicBox) return;

      let inputRect = inputBox.getBoundingClientRect();
      let outputRect = outputBox.getBoundingClientRect();
      let quillBoxRect = quillBox.getBoundingClientRect();

      if (outputRect.top < inputRect.bottom) {
        if (quillBoxRect.bottom < window.innerHeight) {
          cicBox.style.position = 'static';
        } else {
          if (
            this.isHeightAdjustmentsRequired(modeState) &&
            this.verticalScrollDirection === 'up'
          ) {
            this.moveToBreakPoint(modeState, 0);
          }
        }
      } else {
        if (
          (document.body.scrollTop || document.documentElement.scrollTop) <
            this.mobileBaseScrollTopPos - 10 &&
          this.verticalScrollDirection === 'down'
        ) {
          this.moveToBreakPoint(modeState, 1);
        }
        if (quillBoxRect.bottom >= window.innerHeight) {
          cicBox.style.position = 'sticky';
        }
      }
    }
  };

  this.moveToBaseScrollTopPos = modeState => {
    if (!modeState?.isMobile) return;
    let newPos = this.mobileBaseScrollTopPos;
    // if (!isNaN(forcedPos)) {
    //   newPos = forcedPos;
    // }
    document.body.scrollTop = newPos;
    document.documentElement.scrollTop = newPos;
  };

  this.moveToBreakPoint = (modeState, bp) => {
    if (!modeState?.isMobile) return;
    const bpHeight = CONSTANTS.mobileBreakPoints[bp];
    if (this.currentSetBreakPoint === bpHeight) return;

    let inputBox = document.getElementById('inputText');
    if (!inputBox) return;

    if (this.debounceBreakPointMove) {
      return;
    } else {
      this.debounceBreakPointMove = true;
      setTimeout(() => {
        this.debounceBreakPointMove = false;
      }, 500);
    }
    inputBox.style.height = `${getPxFromVh(bpHeight, APP_SETTINGS.INIT_WINDOW_HEIGHT)}px`;
    if (bpHeight < this.currentSetBreakPoint) {
      this.moveToBaseScrollTopPos(modeState);
      this.preventMobileScrollForced = true;
      setTimeout(() => {
        this.preventMobileScrollForced = false;
        this.setScrollPosition(modeState);
      }, 150);
    }
    this.currentSetBreakPoint = bpHeight;
    switch (bp) {
      case 0:
        inputBox.style.fontSize = '14px';
        break;
      default:
        inputBox.style.fontSize = '16px';
    }
  };

  this.isHeightAdjustmentsRequired = modeState => {
    if (!modeState?.isMobile) return false;
    const mainContainer = document.getElementById('inOutContainer');
    if (!mainContainer) return;
    const mainContainerRect = mainContainer.getBoundingClientRect();
    const mainContainerHeight = mainContainerRect.height;

    return mainContainerHeight > APP_SETTINGS.INIT_WINDOW_HEIGHT;
  };

  this.stylingOutputContent = (
    word,
    showSentenceRestructureLine,
    showChangeWordColor,
    seg,
    isDraggable,
    showLongestUnchangedWordColor,
    theme,
    isWordFocused
  ) => {
    let style = {};

    style.color = isWordFocused ? theme.specialColors.HIGHLIGHTED_TEXT : theme.palette.text.primary;
    const colorStructChange = word => {
      return (
        CONSTANTS.colorStructChanges &&
        word.under &&
        !CONSTANTS.highlightLongestSubstr &&
        !CONSTANTS.displayDiff &&
        !CONSTANTS.highlightInfluentialWords &&
        showSentenceRestructureLine
      );
    };

    if (word.different && CONSTANTS.colorDifferentWords && showChangeWordColor) {
      style.color = theme.specialColors.WORD_DIFF_COLOR;
    }
    // if (CONSTANTS.HIGHLIGHT_AUTOFLIPPED && word.autoflipped) {
    //   style.color = '#db2adb'; // check
    // }

    if (colorStructChange(word)) {
      style.borderBottom = '2px solid ' + theme.specialColors.STRUCT_DIFF_COLOR;
    }

    if (CONSTANTS.displayDiff) {
      style.color = 'rgb(' + word.diff * 70 + ',0,0)';
    }

    if (CONSTANTS.highlightInfluentialWords) {
      style.color = '#252525';
      style.opacity = Math.pow(word.tfidf, 2) * 3;
    }

    if (seg.color === '#9B51E0' && seg.alts.length > 0) {
      style.color = '#9B51E0';
    }

    seg?.alts?.length > 0 ? (style.cursor = 'pointer') : (style.cursor = 'auto');
    if (isDraggable) style.cursor = 'grabbing';

    let finalColor =
      word.seg?.prompt || word.seg?.color === '#9B51E0'
        ? '#9B51E0'
        : showLongestUnchangedWordColor
        ? theme.specialColors.LCS_COLOR
        : undefined;

    if (CONSTANTS.colorLCS && word.inLongestSubstr && word.seg?.color !== 'red') {
      style.color = finalColor;
    } else {
      if (word.seg?.usedWalt && CONSTANTS.HIGHLIGHT_WALTS) {
        style.color = 'rgb(255, 153, 236)';
      }

      if (word.seg?.autoflipped && CONSTANTS.HIGHLIGHT_AUTOFLIPPED) {
        style.color = '#db2adb';
      }

      if (word.seg?.output.origOut) {
        style.color = theme.palette.text.primary;
      }

      if (finalColor === '#9B51E0') {
        style.color = '#9B51E0';
      }
    }
    return style;
  };

  this.checkForDoubleQuotes = outputSentencesArray => {
    let numberOfQuotes = 0;
    let quoteStatus = 'PRE';
    outputSentencesArray.forEach(outputSentence => {
      numberOfQuotes += outputSentence.text.split(`"`).length - 1;
    });

    if (numberOfQuotes % 2 !== 0) return outputSentencesArray;

    return outputSentencesArray.map(outputSentence => {
      if ((outputSentence.text.split('"').length - 1) % 2 === 0) return outputSentence;

      let quoteIndex = -1;

      if (quoteStatus === 'PRE') {
        quoteIndex = outputSentence.text?.trim().indexOf('"');
        quoteStatus = 'POST';
        return {
          ...outputSentence,
          pre: quoteIndex,
          post: -1,
          quoteIndex,
        };
      }
      if (quoteStatus === 'POST') {
        quoteIndex = outputSentence.text?.trim().lastIndexOf('"');
        quoteStatus = 'PRE';
        return {
          ...outputSentence,
          post: quoteIndex,
          pre: -1,
          quoteIndex,
        };
      }
    });
  };

  this.dataFetchingWithRestrictions = (httpRequest, time, errorLabel, errorMsg) =>
    new Promise(function (resolve, reject) {
      let timer = setTimeout(() => {
        reject(new Error(errorMsg));
        logger(errorLabel, errorMsg);
      }, time);
      httpRequest.then(
        apiResponse => {
          clearTimeout(timer);
          resolve(apiResponse);
        },
        apiError => {
          clearTimeout(timer);
          reject(apiError);
        }
      );
    });

  this.getText = text => {
    const inputRef = document.getElementById('inputText');
    inputRef.focus();
    inputRef.contentEditable = 'true';
    inputRef.innerText = '';
    if (detectAgent().isIE) {
      insertTextAtCursor(text);
    } else {
      document.execCommand('insertText', false, text);
    }
    if (this.inputOnChange && typeof this.inputOnChange === 'function') this.inputOnChange(true);
  };

  this.loadDictionaryData = () => {
    if (!this.us2ukData)
      axios.get('/jsonData/us2uk_updated20_6.json').then(res => {
        this.us2ukData = res.data;
      });

    //Assuming ParaModel request will resolve before single para call.
    if (!this.us2auData)
      axios.get('/jsonData/us2au_updated25_5.json').then(res => {
        this.us2auData = res.data;
      });

    if (!this.profaneWords)
      axios.get('/jsonData/profane_words.json').then(res => {
        this.profaneWords = res.data;
      });
  };

  /**
   * Taking input text and replace cyrilicCharacter if present
   */
  this.checkCyrillicCharacters = text => {
    if (!this.cyrilicCharacter) this.cyrilicCharacter = cyrilicData;
    let cyrilicReplacedText = text;
    for (let i = 0; i < text.length; i++) {
      if (this.cyrilicCharacter)
        if (this.cyrilicCharacter[text[i]]) {
          cyrilicReplacedText = text.replace(text[i], this.cyrilicCharacter[text[i]]);
        }
    }

    return cyrilicReplacedText;
  };

  /**
   * Creates new paraphraser object for each sentence
   * and storing it in the paraphraser array
   */
  this.makeNewParaphraser = (text, indent, isDesktop, isMulti, quoteIndex = -1) => {
    if (text !== null && text !== undefined && typeof text === 'string' && text.length > 0) {
      var p = new Paraphraser(
        text,
        0,
        indent,
        this.submissionID,
        !isDesktop && isMulti,
        quoteIndex
      );
      p.index = this.paraphrasers?.length;
      this.paraphrasers.push(p);
    }
  };

  this.createSentenceFromInput = async (input, strength, isDesktop, isIE, wordFlipperValue) => {
    // try {
    // dataFetchingWithTimeout() will make sure to fallback to sentence-splitter lib in case API takes time to resolve.
    // let response = await this.dataFetchingWithRestrictions(
    //   sentenceSplitter({ text: input },true,1000),
    //   3000,
    //   'API timeout reached',
    //   'Data fetch is not executed within 3000 ms, Falling back to sentence-splitter UI lib'
    // );
    let response = await sentenceSplitter({ text: input }, true);

    let sentenceArray = this.checkForDoubleQuotes(response.sentences);
    let numSents = sentenceArray?.length;
    this.outputEdited = false;
    Track.submittedInput(
      input,
      this.submissionID,
      wordFlipperValue,
      strength,
      numSents,
      'sentenceSplitterAPI',
      this.inputLanguage
    );
    let isMulti = numSents > 1;
    let indent = '';
    let indentArray = [];
    sentenceArray.forEach(sentenceObj => {
      const newLineRegEx = /[\r\n ]+$/; //RegEx for space or new line at the end of sentences
      this.makeNewParaphraser(sentenceObj.text, indent, isDesktop, isMulti, sentenceObj.quoteIndex);
      if (newLineRegEx.test(sentenceObj.text)) {
        indentArray = newLineRegEx.exec(sentenceObj.text);
        indent = indentArray[0];
        if (sentenceObj.text.replace(newLineRegEx, '').trim().length != 0)
          sentenceObj.text = sentenceObj.text.trim().replace(newLineRegEx, '');
      }
    });
    // } catch (error) {
    //   //Falling back to sentence-splitter lib in case of timeout or API fail.
    //   Bugsnag.notify({
    //     ...error,
    //     name: 'Sentence-splitter api failed',
    //     errorMessage: error?.message,
    //   });
    //   let sentences = splitIntoSentences(input);
    //   let numSents = 0;
    //   sentences.forEach(s => {
    //     if (s.type === 'Sentence' && s.raw.length > 2) {
    //       numSents += 1;
    //     }
    //   });
    //   Track.submittedInput(
    //     input,
    //     this.submissionID,
    //     QUILL_SETTINGS.fthresh,
    //     strength,
    //     numSents,
    //     'sentenceSplitterLibrary',
    //     this.inputLanguage
    //   );

    //   let isMulti = numSents > 1;
    //   let begun = false;
    //   let linespace = '';
    //   let numberOfLineSpace = 0;
    //   sentences.forEach(s => {
    //     if (s.type === 'Sentence') {
    //       begun = true;
    //       if (isIE) {
    //         let offsetForLines = Math.round(linespace.length / 3) + 1;
    //         linespace = linespace.substring(0, offsetForLines);
    //       }
    //       this.makeNewParaphraser(s.raw, linespace, isDesktop, isMulti);
    //       linespace = '';
    //       numberOfLineSpace = 0;
    //     } else if (s.type === 'WhiteSpace') {
    //       if (begun) {
    //         linespace += s.raw;
    //         numberOfLineSpace += 1;
    //       }
    //     }
    //   });
    // }
  };

  this.handleCompareModeCall = (isOpencompareModeDrawer, isPremium) => {
    // Call the compare Mode function if user Paraphrase the sentence
    if (isOpencompareModeDrawer && this.focusedParaphraser) {
      if (isPremium) this.focusedParaphraser.compareModeOn();
      else this.focusedParaphraser.compareModeOnNonPremium();
    }

    this.completedParaphrase();
    // Stats.updateStats();
    Logger('Quill Finished', 'all is done');
  };

  this.pidArray = [];
  this.batchSetTimeoutTimer = 0;
  this.batchDispatchCall = (dispatch, pID, limit = 2) => {
    if (pID) this.pidArray.push(pID);

    if (this.pidArray.length > limit) {
      dispatch(setOutputParaphraserUpdater(this.pidArray));
      this.pidArray = [];
      clearTimeout(this.batchSetTimeoutTimer);
      this.batchSetTimeoutTimer = 0;
    }

    if (this.pidArray.length && !this.batchSetTimeoutTimer) {
      this.batchSetTimeoutTimer = setTimeout(() => {
        dispatch(setOutputParaphraserUpdater(this.pidArray));

        this.pidArray = [];
        this.batchSetTimeoutTimer = 0;
      }, 500);
    }
  };

  this.markLongestSubString = (original, words) => {
    //original = replaceAll(original.toLowerCase(), ',',' ,');
    original = original.toLowerCase();

    var comp = words.map(w => w.word.toLowerCase()).join(' ');
    var comp2 = comp.slice();
    var original2 = original.slice();
    var lcs = '';
    if (original.length > 2500) {
      var orig_chunks = chunkSubstr(original, 1000);
      var comp_chunks = chunkSubstr(comp, 1000);
      var max_lcs = '';
      for (var i = 0; i < Math.min(orig_chunks.length, comp_chunks.length); i++) {
        var o = orig_chunks[i];
        var c = comp_chunks[i];
        lcs = longestCommonSubstring(o, c).trim();
        if (lcs.length > max_lcs.length) {
          max_lcs = lcs;
        }
      }
      lcs = max_lcs; //longestCommonSubstring(original, comp).trim()
    } else {
      lcs = longestCommonSubstring(original, comp).trim();
    }
    original = original2;
    comp = comp2;
    // @TODO: check log implementation
    // log('lcs', 'original: ', original)
    // log('lcs', 'comp: ', comp)
    // log('lcs', 'lcs: ', lcs)
    var start = comp.indexOf(lcs);
    var end = start + lcs.length;
    if (start === -1) {
      return;
    }
    // @TODO: check log implementation
    // log('lcs', 'start, end: ', start, start + lcs.length);
    var chars = 0;
    words.forEach(w => {
      var wordlen = w.word.length;
      var word_start = chars;
      var word_end = chars + wordlen;
      chars += wordlen;
      // @TODO: check log implementation

      // log('lcs', 'start, end, chars', w.word, start, end, chars);
      if (chars >= start && chars - wordlen <= end) {
        w.inLongestSubstr = true;
        if (start > word_start) {
          w.lcsRightOffset = word_end - start;
          w.inLongestSubstr = false;
          // @TODO: check log implementation
          // log('lcs', 'RIGHT-OFFSET', w.word, word_end - start);
        }
        if (end < word_end) {
          w.inLongestSubstr = false;
          w.lcsLeftOffset = end - word_start;
          // @TODO: check log implementation
          // log('lcs', 'LEFT-OFFSET', w.word, end - word_start);
        }
      }
      chars += 1;
    });

    /* Check the array if there is less than 4 consecutive words marked as longest
    substring than mark them false */

    /* noLongLimit contanis the consecutive words which we have to mark  
    false as they all sum's less then 4 words  */
    let noLongLimit = -1;
    for (let currentIndex = 0; currentIndex < words.length; currentIndex++) {
      if (noLongLimit > 0) {
        noLongLimit -= 1;
        words[currentIndex].inLongestSubstr = false;
        continue;
      }
      if (words[currentIndex].inLongestSubstr) {
        if (this.checkNumberOfWords(words, currentIndex) >= 4) {
          currentIndex = currentIndex + this.checkNumberOfWords(words, currentIndex);
        } else {
          noLongLimit = this.checkNumberOfWords(words, currentIndex);
          words[currentIndex].inLongestSubstr = false;
          noLongLimit -= 1;
        }
      }
    }

    return words;
  };

  this.makeUnderlines = (origText, t2) => {
    var extreme_stop_words = [
      'a',
      'the',
      'of',
      'on',
      'is',
      'to',
      'with',
      'if',
      'and',
      'by',
      'it',
      'be',
      'are',
      'at',
      'from',
      'as',
    ];
    var t1 = origText
      .replace(/([.?,*+^$[\]\\(){}|-])/g, ' $1')
      .split(' ')
      .map(s => s.toLowerCase());
    var indices = [];
    var occs = {};

    t1.forEach(w => {
      occs[w] = 0;
    });
    for (var i = 0; i < t2.length; i++) {
      var word = t2[i]['word'].toLowerCase();
      var cI = -1;
      if (occs[word]) {
        if (t1.slice(occs[word]).includes(word)) {
          cI = t1.indexOf(word, occs[word]);
        }
      } else if (t1.includes(word)) {
        cI = t1.indexOf(word);
      }
      if (t2[i]['pos'] === 'punct') {
        cI = -1;
      }
      indices.push(cI);
      occs[word] = Math.max(cI + 1, 0);
    }

    // SWEAP RIGHTWARD
    var cIndex = [];
    i = 0;
    var accounted = t2.length;
    var overload_handler = 0;
    while (accounted > 0) {
      overload_handler += 1;
      if (overload_handler > 20000) {
        break;
      }
      var start = indices[i];
      var c = [start, start];
      if (start !== 1) {
        var pos = indices[i];
        var end = i + 1;
        for (var j = end; j < t2.length; j++) {
          var next_num = indices[j];
          if (next_num === -1) continue;
          if (next_num === pos + 1) {
            c[1] = indices[j];
            pos = next_num;
          } else {
            break;
          }
        }
      }

      var d = c[1] - c[0];
      i += d + 1;
      accounted -= d + 1;
      cIndex.push(c);
    }

    var last_max = -1;
    var last_tail = -1;
    var sets = [];
    var k = 0;
    cIndex.forEach(c => {
      var a = c[0];
      var b = c[1];
      if (a === -1) return;
      if (a > last_max) {
        last_max = a;
        last_tail = b;
        return;
      }
      var diff = last_tail - a;
      if (b - a === 0 && diff > 10) return;

      var x = indices.indexOf(last_max);
      var y = indices.indexOf(b);

      if (b - a === 0 && extreme_stop_words.includes(t2[y]['word'])) return;

      var overload = 0;
      while (cIndex[k + 1][0] === -1) {
        overload += 1;
        if (overload > 20000) {
          break;
        }
        y += 1;
        k += 1;
      }

      sets.push([x, y]);
      k += 1;
    });

    for (i = 0; i < t2.length; i++) {
      var under = false;
      for (var r = 0; r < sets.length; r++) {
        var s = sets[r];
        if (i >= s[0] && i <= s[1]) {
          under = true;
        }
      }
      t2[i]['under'] = under;
    }

    return t2;
  };

  this.markDifferent = (original, words) => {
    var difftext = original.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
    words.forEach(word => {
      var subtext = word.word;
      subtext = subtext.replace("'s", '');
      subtext = subtext.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
      var isDiff = !difftext.includes(subtext);
      word.different = isDiff;
    });
    return words;
  };

  this.filterFlipResult = (fthresh, text) => {
    let fValue = 9;
    if (WaltCache.flips[text] !== undefined) {
      if (fthresh === 3) fValue = 4;
      else if (fthresh === 2) fValue = 7;
      else if (fthresh === 1) fValue = 9;
      else if (fthresh === 0) fValue = 100;

      let filteredArray = WaltCache.flips[text];
      filteredArray = filteredArray.filter(flip => {
        return flip[2] >= fValue;
      });

      return filteredArray;
    }
  };

  this.applyFlipsToText = text => {
    let altedText = text;
    let wordSegmentsOfFrozenWordToSKip = [];
    const outputTextSplitterRegEx = /\w+|\s+|[^\s\w]|"|❝|❞|“|“|”|‟+/g;

    const quotes = ['"', '❝', '❞', '“', '“', '”', '‟'];
    let textArr = text.match(outputTextSplitterRegEx) || [];
    let quoteSplitSegments = text.split('"');
    let areQuotationsValid = false;
    if (quoteSplitSegments.length % 2 == 0) {
      console.log(
        "From Output: Incorrect opening and closing of quotations in supplied statement. So ignoring 'Paraphrase Quotations' setting"
      );
    } else {
      areQuotationsValid = true;
    }
    let inQuotation = false;
    // let fthreshStr =
    //   this.fthresh !== null && this.fthresh !== undefined
    //     ? this.fthresh
    //     : getReduxStore()?.getState()?.pphr?.wordFlipperValue;

    let fthreshStr = getReduxStore()?.getState()?.pphr?.wordFlipperValue;

    // let beamKey = fthreshStr + '~' + this.initText;
    // Don't remove. Code to be used when flipper upgrades
    let beamKey = text;

    if (WaltCache.flips[beamKey] !== undefined) {
      let waltMap = {};
      // WaltCache.flips[beamKey].forEach(w => {
      //   waltMap[w[0]] = w[1];
      // });
      // Don't remove. Code to be used when flipper upgrades
      this.filterFlipResult(fthreshStr, beamKey).forEach(w => {
        waltMap[w[0]] = w[1];
      });

      let occs = {};
      let altOccs = {};
      let altedTextArr = textArr.map((w, index) => {
        let wLo = w.toLowerCase();
        if (occs[wLo] === undefined) {
          occs[wLo] = 0;
        }
        occs[wLo] += 1;

        if (altOccs[wLo] === undefined) {
          altOccs[wLo] = 0;
        }
        altOccs[wLo] += 1;

        if (quotes.includes(w) && areQuotationsValid) {
          inQuotation = !inQuotation;
          return w;
        }

        if (inQuotation && !QUILL_SETTINGS.ignoreQuotes) {
          // Ignore flip
          return w;
        } else {
          if (wordSegmentsOfFrozenWordToSKip.includes(index)) {
            return w;
          }
          // Apply flip

          // check for freeze word.
          const freezeWords = getReduxStore()?.getState()?.pphr?.freezeWords;
          // check if part of phase
          for (let i = 0; i < freezeWords.length; i += 1) {
            const splittedFrozenWordArrOnSpace = freezeWords[i].trim().split(' ');
            if (textArr[index - 1] && textArr[index - 1] === "'") {
              break;
            }
            // const splittedFrozenWordArrOnRegEx = freezeWords[i].match(outputTextSplitterRegEx);
            if (splittedFrozenWordArrOnSpace.length > 1) {
              let partOfPhrase = true;
              const _wordSegmentsOfFrozenWordToSKip = [];
              let j = 0;
              for (j; j < splittedFrozenWordArrOnSpace.length; j += 1) {
                if (
                  splittedFrozenWordArrOnSpace[j].trim().toLowerCase() !==
                  textArr[index + j].trim().toLowerCase()
                ) {
                  partOfPhrase = false;
                  break;
                } else {
                  _wordSegmentsOfFrozenWordToSKip.push(index + j);
                }
              }
              if (textArr[index + j] && textArr[index + j] === "'") {
                partOfPhrase = false;
              }
              // const isTheWEnded = textArr[index + j] ==='';
              if (partOfPhrase) {
                wordSegmentsOfFrozenWordToSKip = [..._wordSegmentsOfFrozenWordToSKip];
                return w;
              }
            } else {
              let individuallyPresent = true;
              if (
                (textArr[index - 1] && textArr[index - 1] === "'") ||
                splittedFrozenWordArrOnSpace[0].trim().toLowerCase() !==
                  textArr[index].trim().toLowerCase() ||
                (textArr[index + 1] && textArr[index + 1] === "'")
              ) {
                individuallyPresent = false;
              }
              if (individuallyPresent) {
                return w;
              }
            }
          }
          let wKey = wLo + '~' + occs[wLo];
          if (waltMap[wKey] && waltMap[wKey] !== '') {
            let wText = waltMap[wKey];
            if (altOccs[wText] === undefined) {
              altOccs[wText] = 0;
            }
            altOccs[wText] += 1;
            altOccs[wLo] -= 1;
            let altKey = wText + '~' + altOccs[wText];

            if (w[0] === w[0].toUpperCase()) {
              wText = wText[0].toUpperCase() + wText.slice(1);
            }
            // appliedAlts.push({orig: w, alt: wText, key: wKey});
            return wText;
          } else {
            return w;
          }
        }
      });
      altedText = altedTextArr.join('');
    }
    return altedText;
  };

  /**
   * Method to return beam array. If no. of beams is less than 3, then make an API call to get more beams.
   * @param popperStrength strength seleted in the beam popper
   * @returns beams array for a particular strength
   */
  this.getBeamsArray = async popperStrength => {
    let beams = new Set(null);

    if (
      getWordCount(ParaModel.focusedParaphraser?.origText) < 2 ||
      ParaModel.focusedParaphraser?.origText?.length < 10
    )
      return Array.from(beams);

    if (ParaModel.focusedParaphraser.activeBeamsForEachMode[popperStrength])
      beams.add(ParaModel.focusedParaphraser.activeBeamsForEachMode[popperStrength]);
    ParaModel.focusedParaphraser?.beams[popperStrength]?.forEach(eachBeam => beams.add(eachBeam));
    if (beams.size <= 3) {
      await ParaModel.focusedParaphraser.freedom({
        text: ParaModel.focusedParaphraser.origText,
        strength: popperStrength,
      });
      ParaModel.focusedParaphraser?.beams[popperStrength]?.forEach(eachBeam => beams.add(eachBeam));
    }
    return Array.from(beams);
  };

  this.checkNumberOfWords = (words, i) => {
    let longWordCheckIndex = i;
    for (longWordCheckIndex; longWordCheckIndex < words.length; longWordCheckIndex++) {
      if (!words[longWordCheckIndex].inLongestSubstr) return longWordCheckIndex - i;
    }
    return longWordCheckIndex - i;
  };

  this.getEditLogsOfAllParaphraser = () => {
    return ParaModel.paraphrasers.map(p => {
      var log = p.focusedOutput && p.focusedOutput.editLog ? p.focusedOutput.editLog : {};
      log.paraTime = p.focusTime + getTimeDifference(p.focusTimeStart);
      log.pid = p.pID;
      log.outTimes = p.outputs.map(o => [
        o.outID,
        o.focusTime + getTimeDifference(o.focusTimeStart),
        o.strength,
      ]);
      return log;
    });
  };

  this.callRequillTrackCall = () => {
    let logs = this.getEditLogsOfAllParaphraser();
    let editLog = {
      logs: logs,
    };

    Track.requillArticle(
      getReduxStore()?.getState()?.pphr?.lastSubmission.length,
      getReduxStore()?.getState()?.pphr?.lastSubmission,
      this.getModifiedArticle(),
      editLog,
      this?.submissionID,
      getReduxStore()?.getState()?.pphr?.strength,
      getReduxStore()?.getState()?.pphr?.wordFlipperValue
    );
  };
})();

export default ParaModel;
